import { Tooltip } from '@/shared/components/Tooltip'
import type { ProviderVersionFinding } from '@/lib/apiTypes'

/** How the terramantle patched build relates to one CVE, for the Vulnerabilities table's
 *  "Patched" column. `mark` is the glyph; `tone` picks the colour; `tip` explains it. */
export interface PatchState {
  mark: '✓' | '✗' | '…' | '—'
  tone: 'green' | 'red' | 'amber' | 'muted'
  tip: string
}

export const PATCH_TONE: Record<PatchState['tone'], string> = {
  green: 'var(--green)', red: 'var(--red)', amber: 'var(--amber)', muted: 'var(--text3)',
}

export function PatchMark({ state }: { state: PatchState }) {
  return (
    <Tooltip text={state.tip} placement="top">
      <span tabIndex={0} aria-label={state.tip} style={{ color: PATCH_TONE[state.tone], fontWeight: 600, cursor: 'help', fontSize: '0.85rem' }}>
        {state.mark}
      </span>
    </Tooltip>
  )
}

/** Comparison-entry -> finding-shaped row, so CVEs the comparison knows about but the upstream
 *  findings list does not (introduced by the patch, or report-only majors) render with the same
 *  cells as every other row. */
export function entryAsFinding(e: { cve_id: string; severity: string; pkg: string | null; from?: string | null; to?: string | null; fixed_in?: string }): ProviderVersionFinding {
  return {
    cve_id: e.cve_id, severity: e.severity.toLowerCase(), pkg_name: e.pkg,
    installed_version: e.from ?? null, fixed_version: e.to ?? e.fixed_in ?? null,
    fixable: false, cvss_score: null, primary_url: null,
  }
}
